<div class="modal-header" style="background-color:#f5f5f5;display: block;" appCustomAutofocus>
    <div class="row">
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <h5 class="modal-title" style="margin-top: 5px;">Group Time Off</h5>
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <button type="button" class="btn btn-outline-dark float-right" (click)="closeClicked()">
                Close
            </button>
        </div>
    </div>
</div>
<div class="modal-body" #modalSize>
    <div>
        <div class="row" style="margin-bottom:15px;">
            <div class="col-lg-4">
                <label><strong>Show Requests By Month</strong></label>
                <div class="input-group">
                    <input type="text"
                           class="form-control"
                           bsDatepicker
                           [(ngModel)]="formData.selectedMonth"
                           [outsideClick]="true"
                           [bsConfig]="datePickerOptions"
                           [readonly]="mobileMode"
                           (ngModelChange)="grid?.monthChange()"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-dark" (click)="grid?.monthChange()" *ngIf="!monthChangeTrigger"><span><i class="modus-icons align-bottom">refresh</i></span></button>
                        <button type="button" class="btn btn-warning" (click)="grid?.monthChange()" *ngIf="monthChangeTrigger"><span><i class="modus-icons align-bottom">refresh</i></span></button>
                    </div>
                </div>
            </div>
            <div class="pull-right col-lg-8" style="margin-top:25px;">
                <span style="margin-right:20px;">
                    <span style="background-color:#5cb85c;color:white;font-size:16px;padding:5px;">
                        <i class="modus-icons align-bottom">circle_check_outline</i>
                    </span> Approved
                </span>
                <span style="margin-right:20px;">
                    <span style="background-color:red;color:white;font-size:16px;padding:5px;">
                        <i class="modus-icons align-bottom">circle_close</i>
                    </span> Rejected
                </span>
                <span style="margin-right:20px;">
                    <span style="background-color:#ECC816;color:white;font-size:16px;padding:5px;">
                        <i class="modus-icons align-bottom">help</i>
                    </span> Pending
                </span>
                <span style="margin-right:20px;"><span style="background-color:#00c4ff;color:white;font-size:16px;padding:5px;"><i class="modus-icons align-bottom">car_front</i></span> Holiday</span>
            </div>
        </div>
        <div id="timeOffGridContainer"></div>
            <datatable style="width: 100%" #timeoffGrid (selectedData)="updateData($event)" [formData]="formData" [company]="userData.PRCo" [userKeyID]="userData.UserKeyID"></datatable>
        <p *ngIf="(grid?.monthData?.length==0 && formData.selectedMonth != 0)">No Time Off Request for this month.</p>

        <div *ngIf="data != null" style="margin-top:15px;">
            <label *ngIf="data['LeaveCode']?.length > 0"><strong>Leave Code:</strong></label> {{data["LeaveCode"]}}<br />
            <label><strong>From:</strong></label> {{data["FromDate"]}}<br />
            <label><strong>To:</strong></label> {{data["ToDate"]}}<br />
            <label><strong>Total Hours:</strong></label> {{data["Hours"]}}<br />
        </div>
    </div>
</div>